module.exports = __webpack_public_path__ + "img/request.0670cd05.svg";